export const faqs = [
  {
    question: '17c 是什么类型的平台？',
    answer: '17c 是一款综合性的效率工具平台，集成了数据管理、团队协作、自动化工作流等核心功能，旨在帮助个人和企业用户提升工作效率，优化业务流程。',
  },
  {
    question: '如何开始使用 17c？',
    answer: '您只需访问 17c 官网，使用手机号或邮箱注册账号，即可免费体验基础功能。注册后可以按照新手引导逐步了解平台的核心操作，通常在10分钟内即可上手。',
  },
  {
    question: '17c 支持哪些平台？',
    answer: '17c 目前支持 Web 端、iOS 和 Android 移动端。您可以在浏览器中直接使用，也可以在各大应用商店下载移动应用。所有平台数据实时同步，无缝切换。',
  },
  {
    question: '17c 的数据安全如何保障？',
    answer: '我们采用银行级别的加密技术保护您的数据，所有数据传输使用 HTTPS 加密协议，数据存储采用多重备份和异地容灾机制。同时，我们严格遵守数据隐私保护法规，绝不会未经授权使用您的数据。',
  },
  {
    question: '17c 是否提供免费版本？',
    answer: '是的，17c 提供功能丰富的免费版本，适合个人用户和初创团队使用。对于需要更多高级功能和大容量存储的用户，我们也提供了不同档位的付费方案，您可以根据需求选择。',
  },
  {
    question: '如何联系 17c 客服？',
    answer: '您可以通过以下方式联系我们：发送邮件至 contact@17c.com、拨打客服热线 400-000-1700、或关注微信公众号 17c_official 在线咨询。我们的客服团队在工作时间内会在15分钟内响应您的需求。',
  },
  {
    question: '团队协作功能如何使用？',
    answer: '在 17c 中创建团队空间后，您可以邀请团队成员加入。团队成员可以共享文件、协同编辑文档、分配任务并追踪进度。管理员可以设置不同成员的权限，确保信息安全。',
  },
  {
    question: '17c 支持与其他工具集成吗？',
    answer: '支持。17c 提供了开放的 API 接口，可以与常用的办公软件、项目管理工具、通讯应用等进行集成。我们也提供了详细的技术文档和示例代码，帮助开发者快速完成对接。',
  },
];